import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const MiniResourceCard = makeShortcode("MiniResourceCard");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <MiniResourceCard slots="image,heading,text,link" repeat="6" theme="light" inRow="3" className="trending-cards end-cards" mdxType="MiniResourceCard" />
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "144px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "100%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/express/add-ons/static/16b34cdd126b609dce0fdc3ee83bfda6/e72e6/arranger.webp 144w"],
            "sizes": "(max-width: 144px) 100vw, 144px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/express/add-ons/static/16b34cdd126b609dce0fdc3ee83bfda6/2aa01/arranger.jpg 144w"],
            "sizes": "(max-width: 144px) 100vw, 144px",
            "type": "image/jpeg"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/express/add-ons/static/16b34cdd126b609dce0fdc3ee83bfda6/2aa01/arranger.jpg",
            "alt": "Arranger",
            "title": "Arranger",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <h3 {...{
      "id": "arranger"
    }}>{`Arranger`}</h3>
    <p>{`Quick arrangement of elements`}</p>
    <p><a parentName="p" {...{
        "href": "https://adobesparkpost.app.link/TR9Mb7TXFLb?addOnId=wh7gmh32l"
      }}>{`Arranger`}</a></p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "144px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "100%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/express/add-ons/static/1dbf52029a28aca7543ca79b75a1b6ed/e72e6/webcam.webp 144w"],
            "sizes": "(max-width: 144px) 100vw, 144px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/express/add-ons/static/1dbf52029a28aca7543ca79b75a1b6ed/2aa01/webcam.jpg 144w"],
            "sizes": "(max-width: 144px) 100vw, 144px",
            "type": "image/jpeg"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/express/add-ons/static/1dbf52029a28aca7543ca79b75a1b6ed/2aa01/webcam.jpg",
            "alt": "Webcam",
            "title": "Webcam",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <h3 {...{
      "id": "webcam"
    }}>{`Webcam`}</h3>
    <p>{`Dock your webcam directly in Adobe Express`}</p>
    <p><a parentName="p" {...{
        "href": "https://adobesparkpost.app.link/TR9Mb7TXFLb?addOnId=w8lk74ilm"
      }}>{`Webcam`}</a></p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "144px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "100%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/express/add-ons/static/bfff19d2d2d8792ee43e5bef5b7f0883/e72e6/color-blindness.webp 144w"],
            "sizes": "(max-width: 144px) 100vw, 144px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/express/add-ons/static/bfff19d2d2d8792ee43e5bef5b7f0883/2aa01/color-blindness.jpg 144w"],
            "sizes": "(max-width: 144px) 100vw, 144px",
            "type": "image/jpeg"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/express/add-ons/static/bfff19d2d2d8792ee43e5bef5b7f0883/2aa01/color-blindness.jpg",
            "alt": "Color Blindness Simulator",
            "title": "Color Blindness Simulator",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <h3 {...{
      "id": "color-blindness-simulator"
    }}>{`Color Blindness Simulator`}</h3>
    <p>{`Color Blindness Simulator`}</p>
    <p><a parentName="p" {...{
        "href": "https://adobesparkpost.app.link/TR9Mb7TXFLb?addOnId=w3n7k0gni"
      }}>{`Color Blindness Simulator`}</a></p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "144px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "100%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/express/add-ons/static/05cf1885a39ba737f06b664897e7db12/e72e6/title-pro.webp 144w"],
            "sizes": "(max-width: 144px) 100vw, 144px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/express/add-ons/static/05cf1885a39ba737f06b664897e7db12/2aa01/title-pro.jpg 144w"],
            "sizes": "(max-width: 144px) 100vw, 144px",
            "type": "image/jpeg"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/express/add-ons/static/05cf1885a39ba737f06b664897e7db12/2aa01/title-pro.jpg",
            "alt": "Title Pro",
            "title": "Title Pro",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <h3 {...{
      "id": "title-pro"
    }}>{`Title Pro`}</h3>
    <p>{`The ultimate addon for stunning animated titles`}</p>
    <p><a parentName="p" {...{
        "href": "https://adobesparkpost.app.link/TR9Mb7TXFLb?addOnId=w24599mji"
      }}>{`Title Pro`}</a></p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "144px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "100%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/express/add-ons/static/71c3e69eba891018d722ef2252d172c1/e72e6/vision-board.webp 144w"],
            "sizes": "(max-width: 144px) 100vw, 144px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/express/add-ons/static/71c3e69eba891018d722ef2252d172c1/2aa01/vision-board.jpg 144w"],
            "sizes": "(max-width: 144px) 100vw, 144px",
            "type": "image/jpeg"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/express/add-ons/static/71c3e69eba891018d722ef2252d172c1/2aa01/vision-board.jpg",
            "alt": "Vision Board",
            "title": "Vision Board",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <h3 {...{
      "id": "vision-board"
    }}>{`Vision Board`}</h3>
    <p>{`Create a feature- rich vision boards in minutes`}</p>
    <p><a parentName="p" {...{
        "href": "https://adobesparkpost.app.link/TR9Mb7TXFLb?addOnId=wgl44lhj3"
      }}>{`Vision Board`}</a></p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "144px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "100%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/express/add-ons/static/db0d1ff5794cb0ddf3f5ccbbebe21111/e72e6/creative-coding.webp 144w"],
            "sizes": "(max-width: 144px) 100vw, 144px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/express/add-ons/static/db0d1ff5794cb0ddf3f5ccbbebe21111/2aa01/creative-coding.jpg 144w"],
            "sizes": "(max-width: 144px) 100vw, 144px",
            "type": "image/jpeg"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/express/add-ons/static/db0d1ff5794cb0ddf3f5ccbbebe21111/2aa01/creative-coding.jpg",
            "alt": "Creative Coding",
            "title": "Creative Coding",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <h3 {...{
      "id": "creative-coding"
    }}>{`Creative Coding`}</h3>
    <p>{`Script creativity with fun block-based programming`}</p>
    <p><a parentName="p" {...{
        "href": "https://adobesparkpost.app.link/TR9Mb7TXFLb?addOnId=w2ji95k72"
      }}>{`Creative Coding`}</a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      